export default "__VITE_ASSET__Dv_5Ocfn__"